module.exports = __webpack_public_path__ + "static/media/product-feature-3.de2655c6.svg";